export const DASHBOARD_META_DESIGNS_ASYNC_ACTION_SUCCESS = 'DASHBOARD_META_DESIGNS_ASYNC_ACTION_SUCCESS';
export const DASHBOARD_META_MENUS_ASYNC_ACTION_SUCCESS = 'DASHBOARD_META_MENUS_ASYNC_ACTION_SUCCESS';
export const DASHBOARD_META_RECIPES_ASYNC_ACTION_SUCCESS = 'DASHBOARD_META_RECIPES_ASYNC_ACTION_SUCCESS';
export const DASHBOARD_META_RESET_STATE = 'DASHBOARD_META_RESET_STATE';

export function dashboardMetaDesignsAsyncActionSuccess(data) {
  return {
    type: DASHBOARD_META_DESIGNS_ASYNC_ACTION_SUCCESS,
    data,
  };
}

export function dashboardMetaMenusAsyncActionSuccess(data) {
  return {
    type: DASHBOARD_META_MENUS_ASYNC_ACTION_SUCCESS,
    data,
  };
}

export function dashboardMetaRecipesAsyncActionSuccess(data) {
  return {
    type: DASHBOARD_META_RECIPES_ASYNC_ACTION_SUCCESS,
    data,
  };
}

export function resetDashboardMetaState() {
  return {
    type: DASHBOARD_META_RESET_STATE,
  };
}
